import ServiceCards from "./ServiceCards";
import ServiceData from "./ServiceData";
import SectionHeading from "./SectionHeading";
import './Services.css';


const Services = () => {
  const today = new Date();

  // ✅ Step 1: Filter only future or today items
  const validData = ServiceData.filter(item => {
    if (!item.endDate) return true; // show items without date
    return new Date(item.endDate) >= today;
  });

  // ✅ Step 2: Sort by nearest date first
  const sortedData = validData.sort((a, b) => {
    const dateA = a.endDate ? new Date(a.endDate) : new Date("2100-01-01");
    const dateB = b.endDate ? new Date(b.endDate) : new Date("2100-01-01");

    return dateA - dateB;
  });

  return (
    <>
      <section className="causes-section1">
        <div className="auto-container">
          <SectionHeading 
            title="Yugal Kunj Services"
            subtitle="Explore our spiritual programs, classes, and community services"
          />

          <div className="yk-events-row">
            {sortedData.map((val) => (
              <ServiceCards
                key={val.serialNo}   // ✅ avoid duplicate id issue
                imgsrc={val.imgsrc}
                title={val.title}
                titleHtml={val.titleHtml}
                Desc={val.Desc}
                Link={val.Link}
                Readbtn={val.Readbtn}
                RegistrationLink={val.RegistrationLink}
                registerbtn={val.registerbtn}
                target={val.target}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;